import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Draft, DraftRequest, FileService, Template, TemplateRequest, Transaction} from "@app/shared";
import {MenuItem} from "primeng/api";
import {UserService} from "@app/core";

@Component({
  selector: 'app-approvable-menu',
  templateUrl: './approvable-menu.component.html',
  styleUrls: ['./approvable-menu.component.css']
})
export class ApprovableMenuComponent implements OnInit, OnChanges {


  @Input() txnType: Transaction; // transaction type enum
  @Input() pdfRequest;
  @Input() draftObject: any;
  @Input() enableTemplate?: boolean = false; // default to false
  @Input() refIdForTemplate?: number;
  @Input() enableChargeCode?: boolean = false; // default to false

  @Output() loadDraft?: EventEmitter<Draft> = new EventEmitter<Draft>();             // get draft event emitter
  @Output() loadTemplate?: EventEmitter<Template> = new EventEmitter<Template>();    // get template event emitter
  @Output() loadDefaultChargeCode?: EventEmitter<boolean> = new EventEmitter<boolean>();                     // Charge Code event emitter

  draftRequest: DraftRequest;
  templateRequest: TemplateRequest;

  menuItems: MenuItem[];

  constructor(
    private fileService: FileService,
    private userService: UserService
  ) {
  }

  ngOnInit() {
    console.log(this.enableChargeCode);
    console.log(this.enableTemplate);
    this.menuItems = [
      {
        icon: 'fa fa-file-pdf-o',
        command: (onclick) => {
          this.onClickViewFile();
        },
        disabled: (!this.pdfRequest || !this.pdfRequest.id)
      },
      {
        icon: 'fa fa-floppy-o',
        items: [
          {
            label: 'Save Draft', visible: true, command: (onclick) => {
              this.saveDraft();
            }
          },
          {
            label: 'Load Draft', visible: true, command: (onclick) => {
              this.getDraft();
            }
          },
          {
            label: 'Save Template',
            visible: (this.enableTemplate === undefined ? false : this.enableTemplate),
            command: (onclick) => {
              this.saveTemplate();
            }
          },
          {
            label: 'Load Template',
            visible: (this.enableTemplate === undefined ? false : this.enableTemplate),
            command: (onclick) => {
              this.getTemplate();
            }
          },
          {
            label: 'Setup Default Charge Code',
            visible: (this.enableChargeCode === undefined ? false : this.enableChargeCode),
            command: (onclick) => {
              this.showDefaultChargeCodeDialog();
            }
          }

        ]
      }
    ];

    // Todo: remove this once pdf template code is done
    // remove PDF icon if  Transaction is JobRequisition
    if (this.txnType == Transaction.JobRequisition) {
      this.menuItems.splice(0, 1);
    }

  }


  ngOnChanges(changes: SimpleChanges) {
    console.log(this.pdfRequest);
    if (this.txnType != Transaction.JobRequisition) {
      if (this.menuItems && this.pdfRequest && this.pdfRequest.id) {
        this.menuItems[0].disabled = false;
      } else if (this.menuItems) {
        this.menuItems[0].disabled = true;
      }
    }
  }


  getDraft() {
    this.draftRequest = new DraftRequest();
    this.draftRequest.request = 'load';
    this.draftRequest.draft = new Draft();
    this.draftRequest.draft.transaction = this.txnType;
  }


  loadDraftFromAppDraft(event) {
    this.loadDraft.emit(event);
  }

  saveDraft() {
    if (this.draftObject) {
      this.draftRequest = new DraftRequest();
      this.draftRequest.request = 'save';
      this.draftRequest.draft = new Draft();
      this.draftRequest.draft.transaction = this.txnType;
      delete this.draftObject.id;    // remove id,currentStatus,approvedBy, approvedOn from the object before saving to draft
      delete this.draftObject.currentStatus;
      delete this.draftObject.approvedBy;
      delete this.draftObject.approvedOn;
      this.draftRequest.draft.jsonString = JSON.stringify(this.draftObject);
    }
  }

  getTemplate() {
    this.templateRequest = new TemplateRequest();
    this.templateRequest.request = 'load';
    this.templateRequest.template = new Template();
  }

  loadTemplateFromAppTemplate(event) {
    this.loadTemplate.emit(event);
  }

  saveTemplate() {
    if (this.refIdForTemplate) {
      this.templateRequest = new TemplateRequest();
      this.templateRequest.request = 'save';
      this.templateRequest.template = new Template();
      this.templateRequest.template.userId = this.userService.info.userId;
      if (this.txnType == Transaction.ExpenseReport) {
        this.templateRequest.template.expenseReportId = this.refIdForTemplate;
      } else if (this.txnType == Transaction.PurchaseRequisition) {
        this.templateRequest.template.purchaseReqId = this.refIdForTemplate;
      } else if (this.txnType == Transaction.SalesOrder) {
        this.templateRequest.template.salesOrderId = this.refIdForTemplate;
      } else if (this.txnType == Transaction.JobRequisition) {
        this.templateRequest.template.jobRequisitionId = this.refIdForTemplate;
      }
    }
  }

  /**
   * @desc download the selected file and view it on a separate browser tab.  a broser tab showing the selected file.
   * @param transaction - transaction type
   * @param refId - transaction reference id (entity row id)
   * @param pdfTemplateId - pdf template id for the transaction
   * @returns the selected file viewed on a separate browser tab
   */

  onClickViewFile() {
    this.fileService.getTxnInPDFThenShowOnNewTab(this.txnType, this.pdfRequest.id, this.pdfRequest.pdfTemplateId);
  }

  showDefaultChargeCodeDialog() {
    this.loadDefaultChargeCode.emit();
  }


}
